module.exports = __webpack_public_path__ + "assets/img/logo-intella-alipay.364489b3.png";